import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Icon } from 'components/common/Elements/Elements';

import classes from './Hooks.module.scss';

const Hooks = ({ family, grands, noLast }) => {
  return (
    <>
      {(family === 'parent' ||
        family === 'child-parent' ||
        (family === 'child' && noLast) ||
        family === 'grandson') && (
        <Icon
          icon="parentS"
          size="48px"
          className={cn(
            classes.hook,
            family === 'parent' && classes.hook_parent,
            family === 'child-parent' && classes.hook_child__parent,
            family === 'child' && classes.hook_child,
            family === 'grandson' && classes.hook_grand
          )}
        />
      )}
      {(family === 'child-parent' ||
        family === 'child' ||
        (family === 'grandson' && noLast)) && (
        <Icon
          icon="parentS"
          size="48px"
          className={cn(
            classes.hook,
            (family === 'child-parent' || family === 'child') &&
              classes.hook_child__up,
            family === 'grandson' && classes.hook_grand__down
          )}
        />
      )}
      {grands && (
        <Icon
          icon="parentLine"
          size="72px"
          className={cn(
            classes.hook,
            family === 'grandson' && classes.hook_grand__line,
            family === 'child-parent' && classes.hook_child__line
          )}
        />
      )}
    </>
  );
};

Hooks.propTypes = {
  family: PropTypes.string,
  noLast: PropTypes.bool,
  grands: PropTypes.bool
};

export default Hooks;
